module.exports = __webpack_public_path__ + "static/media/green-spot.b52c86db.png";